import setSpellerData from '../actions/setSpellerData';
import getScenarioStore from '../store/getScenarioStore';
import { mutator } from 'satcheljs';

mutator(setSpellerData, actionMessage => {
    const {
        alteredQuery,
        suggestedSearchTerm,
        suggestedSearchTermReferenceId,
        flaggedTokens,
        recourseQuery,
        queryAlterationType,
        scenarioId,
    } = actionMessage;

    const store = getScenarioStore(scenarioId);
    store.alteredQuery = alteredQuery;
    store.suggestedSearchTerm = suggestedSearchTerm;
    store.suggestedSearchTermReferenceId = suggestedSearchTermReferenceId;
    store.flaggedTokens = flaggedTokens;
    store.recourseQuery = recourseQuery;
    store.queryAlterationType = queryAlterationType;
});
